module.exports = __webpack_public_path__ + "img/success.be0376fc.svg";